import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { accessGalleryDirectLogin, loginUser, setAuthToken } from '../services/api';

type DirectLoginGallery = {
    id: string | number;
    accessToken?: string;
};

const parseDirectLoginGalleries = (value: any): DirectLoginGallery[] => {
    if (!Array.isArray(value)) return [];
    return value
        .map((entry) => ({
            id: entry?.id,
            accessToken: entry?.accessToken,
        }))
        .filter((entry) => entry.id !== undefined && entry.id !== null);
};

const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const history = useHistory();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        try {
            const data = await loginUser({ email, password });
            if (data?.token) {
                setAuthToken(data.token);
            }
            history.replace('/admin');
            return;
        } catch (adminError) {
            // Admin login failed. Continue with private gallery direct login fallback.
        }

        const galleryLoginUsername = email.trim();
        const galleryLoginPassword = password.trim();

        if (galleryLoginUsername !== galleryLoginPassword) {
            setError('Invalid email or password');
            return;
        }

        try {
            const data = await accessGalleryDirectLogin({ username: galleryLoginUsername, password: galleryLoginPassword });
            const galleries = parseDirectLoginGalleries(data?.galleries);

            if (!galleries.length) {
                setError('Kunne ikke åbne skjulte gallerier');
                return;
            }

            const accessibleGalleryIds: string[] = [];
            galleries.forEach((gallery) => {
                const galleryId = String(gallery.id || '');
                if (!galleryId || !gallery.accessToken) return;
                sessionStorage.setItem(`galleryAccessToken:${galleryId}`, gallery.accessToken);
                accessibleGalleryIds.push(galleryId);
            });

            if (!accessibleGalleryIds.length) {
                setError('Kunne ikke åbne skjulte gallerier');
                return;
            }

            sessionStorage.setItem('directLoginGalleryIds', JSON.stringify(accessibleGalleryIds));
            history.replace('/galleries?source=direct-login');
        } catch (galleryError) {
            setError('Forkert kode til skjult galleri');
        }
    };

    return (
        <div className="login-container">
            <h2>Login</h2>
            {error && <p className="error">{error}</p>}
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Email or username:</label>
                    <input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Login</button>
            </form>
        </div>
    );
};

export default Login;